import {
    GET_TENANTS_LIST,
    GET_TENANTS_LIST_SUCCESS
} from './constants.js';

/**
 *
 * @returns {{type: string}}
 */
const getTenantsList = () => ({
    type: GET_TENANTS_LIST
});
/**
 *
 * @param tenants
 * @returns {{tenants: *, type: string}}
 */
const getTenantsListSuccess = tenants => ({
    type: GET_TENANTS_LIST_SUCCESS,
    tenants
});

export {
    getTenantsList,
    getTenantsListSuccess
};